import { Directive, ElementRef, Input } from '@angular/core';
import { ProfileService } from '../../core/services/profile/profile';
import { GroupService } from '../../core/services/group/group';

@Directive({
  selector: '[appOnlysuperuser]',
  standalone: true,
})
export class OnlysuperuserDirective {
  @Input('appOnlysuperuser') params: string = '';

  constructor(
    private element: ElementRef,
    private profileService: ProfileService,
    private groupService: GroupService,
  ) {}

  ngOnInit() {
    const profile = this.profileService.getUserProfile();
    const canAccess = this.params.length > 0 ? this.groupService.hasSpecialAccess(profile) : true;
    return this.showElement(canAccess);
  }

  showElement(action: boolean) {
    this.element.nativeElement.style.display = action ? 'flex' : 'none';
  }
}
